import React, { useState } from 'react'
import { Link } from 'gatsby'
import { ThemeToggler } from 'gatsby-plugin-dark-mode'

import { commonContents } from '../../contents'
import './styles.scss'
import '../../styles/animate.scss'
import MyLogo from '../../../static/logo.svg'

const Navigation = ({ show, noActive }) => {
  const isVisible = show ? '' : 'opacity-0'

  return (
    <ul className="navbar-nav">
      {commonContents.pages.map(({ name, href }, i) => {
        return (
          <li
            className={`${isVisible} nav-item top-menu top-menu-${name.toLowerCase()}-container`}
            key={i}
          >
            <Link
              to={href}
              className="nav-link"
              activeClassName={noActive ? '' : 'active'}
            >
              {name}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

const Header = ({ isNavVisible, noActive }) => {
  const [navState, setNavState] = useState(false)

  return (
    <header id="mainHeader" className="container">
      <div className="navbar navbar-dark navbar-expand-md">
        {/* Site Logo */}
        <div className="d-flex align-items-center navbar-brand order-2">
          <h2 className="site-logo animate text-zoom-on-hover m-0">
            <Link to="/">
              <div className="my-logo">
                <img src={MyLogo} alt="My Logo" width="50px" />
              </div>
            </Link>
          </h2>
        </div>
        <button
          className="btn order-1 d-block d-md-none show-side-nav"
          onClick={() => setNavState(!navState)}
        >
          <i className="fas fa-bars"></i>
        </button>
        {/* Main Nav */}
        <div
          className={`order-3 order-md-2 collapse navbar-collapse show ${
            !!navState ? ' show-sideNav' : ''
          }`}
          id="headerMainNav"
        >
          <button
            className="btn order-2 d-block d-md-none close-side-nav"
            onClick={() => setNavState(!navState)}
          >
            <i className="fas fa-times"></i>
          </button>

          <Navigation show={isNavVisible} noActive={noActive} />
        </div>

        {/* Theme Toggler */}
        <div className="theme-switch-wrapper d-flex align-items-center order-3 order-md-2">
          <ThemeToggler>
            {({ theme, toggleTheme }) => (
              <label className="theme-switch">
                <input
                  type="checkbox"
                  onChange={e =>
                    toggleTheme(e.target.checked ? 'dark' : 'light')
                  }
                  checked={theme === 'dark'}
                />
                <div className="slider round"></div>
              </label>
            )}
          </ThemeToggler>
          <span>Dark</span>
        </div>
      </div>
    </header>
  )
}

export default Header
